import { HTMLAttributes } from 'react';
import ImportantInformation from '../ImportantInformation';
import { JobDestinations } from '/types/jobTemplateTypes';

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
    jobDestination: JobDestinations;
    importantNote: string | undefined;
    onChange: (value: string) => void;
}

export default function JobImportantNote({
    importantNote,
    onChange,
    jobDestination,
    ...props
}: Props) {
    return (
        <div {...props}>
            {jobDestination === 'cart' && importantNote ? (
                <ImportantInformation className="mb-80">
                    {importantNote}
                </ImportantInformation>
            ) : (
                <div className="mb-80" />
            )}

            {jobDestination !== 'cart' && importantNote && (
                <ImportantInformation
                    className="mb-80"
                    editable
                    onChange={onChange}
                >
                    {importantNote}
                </ImportantInformation>
            )}
        </div>
    );
}
